import { generateShortToken } from '@/helpers/encrypt'
import { LOGIN_ERROR_MESSAGE } from '@/helpers/errorHandler'
import { Cookie } from '@/mixin/local-cookie'
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client/core'
import { onError } from '@apollo/client/link/error'

// Handler for Error Unauthenticated
const errorHandler = onError(({ graphQLErrors }) => {
  if (graphQLErrors !== undefined) {
    graphQLErrors.forEach(function (item) {
      if (
        item.extensions &&
        (item.extensions.code == 'UNAUTHENTICATED' ||
          item.extensions.code == 'INTERNAL_SERVER_ERROR' ||
          item.message === LOGIN_ERROR_MESSAGE) &&
        !window.location.href.includes('/forgotpassword') &&
        !window.location.href.includes('/unsubscribe')
      ) {
        localStorage.removeItem('token')
        localStorage.removeItem('domainName')
        localStorage.removeItem('domainNameExpired')
        localStorage.removeItem('payload')
        window.location.href = '/login'
      }
    })
  }
})

const pathName = window.location.pathname.split('/')
let authToken = null
let shortToken = null
function isBase64(str) {
  try {
    return btoa(atob(str)) == str
  } catch (err) {
    return false
  }
}
if (pathName.includes('live-track')) {
  var param = window.location.search
  const urlParams = new URLSearchParams(param)

  const token = urlParams.get('token')
  if (token) {
    authToken = token
  }
  const shortKey = urlParams.get('shToken')
  const id = parseInt(pathName[pathName.length - 1])

  shortToken = shortKey ? generateShortToken(id, shortKey) : null

  if (!shortToken && !authToken) {
    window.location.href = '/login'
  }
} else if (
  (pathName.includes('fleet-task') || pathName.includes('fleet-task-instant')) &&
  pathName.includes('track')
) {
  const url = window.location.href
  const parts = url.split('/')
  const target = parts[parts.length - 1]
  let decodedData
  if (isBase64(target)) {
    decodedData = atob(target)
  } else {
    const data = {
      hasButton: false,
    }
    localStorage.setItem('404', JSON.stringify(data))
    window.location.href = '/404'
  }
  const regex = /token=([^&]+)/
  const token = decodedData.match(regex)[1]
  authToken = token
} else {
  const localCookie = Cookie.getLocalCookie()
  const feHost = Cookie.getMainDomain(window.location.host)
  const beHost = Cookie.getMainDomain(process.env.VUE_APP_API_URL)
  if (localCookie.resource && feHost != beHost) {
    authToken = localCookie.resource
  }
}

const headers = {
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
}
if (authToken) {
  headers.authorization = `Bearer ${authToken}`
}
if (shortToken) {
  headers.shorttoken = shortToken
}
const httpLink = new HttpLink({
  uri: process.env.VUE_APP_API_URL,
  credentials: 'include',
  headers:
    Object.keys(headers).length > 0
      ? headers
      : {
          priority: 'normal',
        },
  errorHandler,
})

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: errorHandler.concat(httpLink),
  fetchPolicy: 'no-cache',
})

const httpLinkLowPrio = new HttpLink({
  uri: process.env.VUE_APP_API_URL,
  credentials: 'include',
  headers:
    Object.keys(headers).length > 0
      ? headers
      : {
          priority: 'low',
        },
  errorHandler,
})

export const clientLowPrio = new ApolloClient({
  cache: new InMemoryCache(),
  link: errorHandler.concat(httpLinkLowPrio),
  fetchPolicy: 'no-cache',
})

const httpLinkRateLimit = new HttpLink({
  uri: process.env.VUE_APP_API_URL,
  credentials: 'include',
  headers:
    Object.keys(headers).length > 0
      ? headers
      : {
          priority: 'rate-limit',
        },
  errorHandler,
})

export const clientRateLimit = new ApolloClient({
  cache: new InMemoryCache(),
  link: errorHandler.concat(httpLinkRateLimit),
  fetchPolicy: 'no-cache',
})
